export const getMonths = (startDate, endDate) => {
    let current = new Date(startDate.getFullYear(), startDate.getMonth(), 1);
    const end = new Date(endDate.getFullYear(), endDate.getMonth(), 1);

    const result = {};
    while (current <= end) {
        const year = current.getFullYear();
        const month = current.getMonth() + 1;

        if (!result[year]) result[year] = [];
        result[year].push(month.toString().padStart(2, '0'));

        current.setMonth(current.getMonth() + 1);
    }

    return result;
}